// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 4a).
// Tab "Historial de Cambios" — 1:1 move del JSX. Recibe los datos y las
// interacciones (abrir detalle de servicio, abrir edición de ubicación,
// formateo de fecha) como props para poder navegar a los modales que viven
// en el padre.
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Clock, FileText, User } from "lucide-react";
import { toast } from "sonner";

export const HistorialTab = ({
  auditLogs,
  services,
  locations,
  setSelectedService,
  setServiceDetailOpen,
  openEditLocation,
  formatDateTime,
}) => {
  return (
    <Card className="bg-[#0A0A35] border-[#1E1E5F]">
      <CardHeader>
        <CardTitle className="text-white font-heading flex items-center gap-2">
          <Clock className="h-5 w-5 text-[#03BEE4]" />
          Historial de Cambios
        </CardTitle>
        <CardDescription className="text-slate-400">
          Registro de todas las modificaciones realizadas
        </CardDescription>
      </CardHeader>
      <CardContent>
        {auditLogs.length === 0 ? (
          <div className="text-center py-8">
            <FileText className="h-12 w-12 text-slate-500 mx-auto mb-4" />
            <p className="text-slate-400">No hay cambios registrados</p>
          </div>
        ) : (
          <div className="space-y-4">
            {auditLogs.map((log) => (
              <div
                key={log.id}
                className="flex items-start gap-4 p-4 rounded-lg bg-[#1B1B4B]/50 border border-[#1E1E5F]"
              >
                <div className="w-10 h-10 rounded-full bg-[#03BEE4]/20 flex items-center justify-center flex-shrink-0">
                  <User className="h-5 w-5 text-[#03BEE4]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-white font-medium">{log.changed_by_name}</span>
                    <span className="text-slate-400">modificó</span>
                    <Badge className="bg-[#1B1B4B] text-[#03BEE4] border-none">
                      {log.field_label || log.field_name}
                    </Badge>
                    <span className="text-slate-400">en</span>
                    {log.entity_type === "customer_service" ? (
                      <Badge
                        className="bg-[#1B1B4B] text-[#42E695] border-[#42E695]/30 border cursor-pointer hover:bg-[#42E695]/20"
                        onClick={async () => {
                          // Find the service and open its detail modal
                          const service = services.find(s => s.id === log.entity_id);
                          if (service) {
                            setSelectedService(service);
                            setServiceDetailOpen(true);
                          } else {
                            toast.error("Servicio no encontrado");
                          }
                        }}
                      >
                        {log.entity_name || "Servicio"} ↗
                      </Badge>
                    ) : log.entity_type === "location" ? (
                      <Badge
                        className="bg-[#1B1B4B] text-purple-400 border-purple-400/30 border cursor-pointer hover:bg-purple-400/20"
                        onClick={() => {
                          const location = locations.find(l => l.id === log.entity_id);
                          if (location) {
                            openEditLocation(location);
                          } else {
                            toast.error("Ubicación no encontrada");
                          }
                        }}
                      >
                        {log.entity_name || "Ubicación"} ↗
                      </Badge>
                    ) : (
                      <Badge className="bg-[#1B1B4B] text-slate-300 border-none">
                        {log.entity_type === "customer" ? "Cliente" : log.entity_type}
                      </Badge>
                    )}
                  </div>
                  <div className="mt-2 text-sm">
                    <span className="text-red-400 line-through">{log.old_value || "(vacío)"}</span>
                    <span className="text-slate-500 mx-2">→</span>
                    <span className="text-[#42E695]">{log.new_value}</span>
                  </div>
                </div>
                <div className="text-xs text-slate-500 flex-shrink-0">
                  {formatDateTime(log.changed_at)}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
